import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Badge,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
} from "reactstrap"
import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { withRouter, Link, useLocation } from "react-router-dom"
import { getDateString, getOrderPrefix } from "helpers/common_helper"
import { Type } from "react-bootstrap-table2-editor"
import { WindowScrollController } from "@fullcalendar/core"
import { options } from "toastr"


const columns = (handleConfirm) => {
const requestFor = location.pathname.split("/")[2];
  const styles = {
    Paid: { background: "#d1fae5", color: "#065f46" },      // green
    Unpaid: { background: "#fee2e2", color: "#991b1b" },    // red
    // Overdue: { background: "#fef3c7", color: "#92400e" },   // yellow
  };

  const columns = [
    {
      dataField: "Sno",
      text: "S#",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return rowIndex + 1
      },
    },
    {
      dataField: "orderCode",
      text: "Order Code",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
      // style: {color:'red'},
      // className: "text-danger",
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
        <Link to="#" className={row.convertToOrder ? "fw-bold text-danger" : "fw-bold"}>
          {getOrderPrefix(row.requestFor) + row.orderCode}
        </Link>
      ),
    },
    {
      dataField: "orderName",
      text: "Order Name",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
      editor: {
        type: Type.TEXT,
      },
    },
    {
      dataField: "submitDateTime",
      text: "Submit Date",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
      formatter: (cellContent, row) => getDateString(row.submitDateTime),
    },
    {
      dataField: "oStatus",
      text: "Order Status",
      sort: true,
    },
    {
      dataField: "orderStatus",
      text: "Order Status",
      sort: true,
    },
    {
      dataField: "convertToOrder",
      text: "Convert To Order",
      isDummyField: true,
      sort: false,
      editable: false,
      formatter: (cellContent, order) => (
        <>
          <button
            type="button"
            onClick={() => handleConfirm(order.orderCode)}
            className="btn-sm btn-rounded mb-2 me-2 btn btn-primary"
          >
            <i className="mdi mdi-plus me-1"></i> Convert To Order
          </button>
        </>
      ),
    },
    {
      dataField: "edit",
      text: "Edit",
      sort: true,
      formatter: (cellContent, row) => {
        return (<Link to={{
          pathname: `/user/create-${requestFor.split("-")[1].slice(0, -1)}`,
          state: { orderData: row, request: "reOrder"}
        }}>Edit</Link>)
      }
    },
    // {
    //   dataField: "edit",
    //   text: "Edit Order",
    //   sort: true,
    //   formatter: (cellContent, row) => {
    //     return (<Link to={{
    //       pathname: `/user/create-${requestFor.split("-")[1].slice(0, -1)}`,
    //       state: { orderData: row, request: "edit" }
    //     }}>Edit</Link>)
    //   }
    // }

  ]



  let filterdColumns = []
  // helper function to reorder columns
  const reorderColumns = (columns, order) => {
    const map = new Map(columns.map(c => [c.dataField, c]))
    return order.map(key => map.get(key)).filter(Boolean)
  }

  switch (requestFor) {
    case "view-quotes":
      filterdColumns = reorderColumns(columns, [
        "Sno",
        "orderCode",
        "orderName",
        "submitDateTime",
        "orderStatus",
        "assTo",
        "process",
        "convertToOrder",
        "paymentStatus",
        "edit",
        "reOrder"
      ])
      break
    case "view-orders":
      filterdColumns = reorderColumns(columns, [
        "Sno",
        "orderCode",
        "orderName",
        "submitDateTime",
        "orderStatus",
        "assTo",
        "process",
        "edit",
        "paymentStatus",
        "reOrder"

      ])
      break

    case "view-vectors":
      filterdColumns = reorderColumns(columns, [
        "Sno",
        "oStatus",
        "orderCode",
        "submitDateTime",
        "sentDate",
        "userName",
        "orderName",
        "orderStatus",
        "assTo",
        "assToSalesMan",
        "edit",
        "reOrder",
        "action"
      ])
      break


  }

  if (requestFor.split("-")[1].slice(0, -1) !== "quote") {
    filterdColumns.push(
      ({
        dataField: "paymentStatus",
        text: "Payment Status",
        sort: true,
        formatter: (cellContent, row) => {
          return (<b style={{
            padding: "4px 12px",
            borderRadius: "9999px",
            fontSize: "12px",
            fontWeight: "600",
            ...styles[row.paymentStatus ? "Paid" : "Unpaid"],
          }}>{row.paymentStatus ? "paid" : "Unpaid"}</b>)
        }
      })
    )
  }

  return filterdColumns
}

columns.propTypes = {
  handleConfirm: PropTypes.func,
}

export default columns
